import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2022 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Container, Row, Col } from "../index";
import { SangerLogo } from "./Icons";
function Footer() {
    return (_jsx("footer", { className: "footer", children: _jsx(Container, { children: _jsxs(Row, { sm: 1, md: 2, children: [_jsx(Col, { sm: 6, md: 4, lg: 3, children: _jsx("div", { className: "centre", children: _jsx("a", { href: "https://sanger.ac.uk", children: _jsx(SangerLogo, {}) }) }) }), _jsx(Col, { sm: 6, md: { span: 4, offset: 4 }, lg: { span: 3, offset: 6 }, children: _jsx("div", { className: "centre", children: _jsxs("p", { className: "footer-text", children: [_jsx("a", { href: "https://www.sanger.ac.uk/programme/tree-of-life/", children: "Tree of Life Programme" }), _jsx("br", {}), _jsx("a", { href: "https://www.sanger.ac.uk/group/tree-of-life-enabling-platforms/", children: "Enabling Platforms" })] }) }) })] }) }) }));
}
export default Footer;
